<template>
    <div class="test-container">
        <h1>ZLMediaKit 测试页面</h1>

        <div class="controls">
            <div class="form-group">
                <label>ZLMediaKit 服务器地址:</label>
                <input v-model="serverUrl" placeholder="例如: rtmp://localhost/live" />
            </div>

            <div class="form-group">
                <label>流名称:</label>
                <input v-model="streamName" placeholder="例如: test" />
            </div>

            <div class="buttons">
                <button @click="startPlay">开始播放</button>
                <button @click="stopPlay">停止播放</button>
                <button @click="startPublish">开始推流</button>
                <button @click="stopPublish">停止推流</button>
            </div>
        </div>

        <div class="video-container">
            <video
                id="zlmedia-player"
                ref="videoPlayer"
                controls
                autoplay
                muted
                playsinline
            ></video>
        </div>

        <div class="status">
            <p>状态: {{ status }}</p>
            <p>播放地址: {{ playUrl }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'test',
    data() {
        return {
            serverUrl: 'http://localhost:8080',
            streamName: 'test',
            status: '未连接',
            playUrl: '',
            player: null,
            mediaSource: null
        }
    },
    mounted() {
        console.log('ZLMediaKit 测试页面已加载')
    },
    beforeDestroy() {
        this.stopPlay()
    },
    methods: {
        // 开始播放
        async startPlay() {
            try {
                this.status = '正在连接...'
                this.playUrl = `${this.serverUrl}/live/${this.streamName}.flv`

                console.log('播放地址:', this.playUrl)

                // 使用 flv.js 播放 FLV 流
                if (!this.$refs.videoPlayer) {
                    console.error('视频元素未找到')
                    return
                }

                // 动态加载 flv.js
                await this.loadFlvJs()

                if (this.player) {
                    this.player.destroy()
                }

                if (flvjs.isSupported()) {
                    this.player = flvjs.createPlayer({
                        type: 'flv',
                        url: this.playUrl
                    }, {
                        enableWorker: true,
                        enableStashBuffer: false,
                        stashInitialSize: 128
                    })

                    this.player.attachMediaElement(this.$refs.videoPlayer)
                    this.player.load()
                    this.player.play()

                    this.player.on(flvjs.Events.ERROR, (errType, errDetail) => {
                        console.error('播放错误:', errType, errDetail)
                        this.status = '播放错误: ' + errDetail
                    })

                    this.player.on(flvjs.Events.LOADING_COMPLETE, () => {
                        console.log('加载完成')
                        this.status = '加载完成'
                    })

                    this.player.on(flvjs.Events.METADATA_ARRIVED, () => {
                        console.log('元数据到达')
                        this.status = '正在播放'
                    })

                    this.status = '已连接'
                } else {
                    this.status = '您的浏览器不支持 flv.js'
                }
            } catch (error) {
                console.error('播放失败:', error)
                this.status = '播放失败: ' + error.message
            }
        },

        // 停止播放
        stopPlay() {
            if (this.player) {
                this.player.pause()
                this.player.unload()
                this.player.detachMediaElement()
                this.player.destroy()
                this.player = null
            }
            this.status = '已断开'
        },

        // 开始推流 (需要摄像头权限)
        async startPublish() {
            try {
                this.status = '正在获取摄像头...'

                const stream = await navigator.mediaDevices.getUserMedia({
                    video: true,
                    audio: true
                })

                // 将流赋值给 video 元素
                this.$refs.videoPlayer.srcObject = stream
                await this.$refs.videoPlayer.play()

                this.status = '正在推流... (推流功能需要服务端配置)'

                // 注意: 真正的推流需要使用 WebRTC 或通过服务端中转
                // 这里只是演示如何获取摄像头流

            } catch (error) {
                console.error('获取摄像头失败:', error)
                this.status = '获取摄像头失败: ' + error.message
            }
        },

        // 停止推流
        stopPublish() {
            if (this.$refs.videoPlayer && this.$refs.videoPlayer.srcObject) {
                const tracks = this.$refs.videoPlayer.srcObject.getTracks()
                tracks.forEach(track => track.stop())
                this.$refs.videoPlayer.srcObject = null
            }
            this.status = '已断开'
        },

        // 动态加载 flv.js
        loadFlvJs() {
            return new Promise((resolve, reject) => {
                if (window.flvjs) {
                    resolve()
                    return
                }

                const script = document.createElement('script')
                script.src = 'https://cdn.jsdelivr.net/npm/flv.js@1.6.2/dist/flv.min.js'
                script.onload = resolve
                script.onerror = reject
                document.head.appendChild(script)
            })
        }
    }
}
</script>

<style scoped>
.test-container {
    padding: 20px;
    background: #1a1a1a;
    min-height: 100vh;
    color: #fff;
}

h1 {
    text-align: center;
    margin-bottom: 30px;
}

.controls {
    background: #2a2a2a;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
}

.form-group {
    margin-bottom: 15px;
}

.form-group label {
    display: inline-block;
    width: 180px;
}

.form-group input {
    width: 300px;
    padding: 8px;
    border: 1px solid #444;
    border-radius: 4px;
    background: #333;
    color: #fff;
}

.buttons {
    margin-top: 20px;
}

.buttons button {
    margin-right: 10px;
    padding: 10px 20px;
    background: #1890ff;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.buttons button:hover {
    background: #40a9ff;
}

.buttons button:nth-child(2) {
    background: #ff4d4f;
}

.buttons button:nth-child(2):hover {
    background: #ff7875;
}

.video-container {
    background: #000;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 20px;
}

#zlmedia-player {
    width: 100%;
    max-width: 800px;
    display: block;
    margin: 0 auto;
}

.status {
    background: #2a2a2a;
    padding: 15px;
    border-radius: 8px;
}

.status p {
    margin: 5px 0;
}
</style>
